export const initializeGTM = (id) => {
  if (!id) {
    console.warn('Tracking ID not configured.');
    return;
  }

  // Basic check to see if dataLayer exists
  if (window.dataLayer) {
      console.warn('Tracking likely already initialized (dataLayer exists).');
  }

  if (id.startsWith('G-')) {
    // Google Analytics 4 (gtag.js) initialization
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', id);
    
    console.log(`Google Analytics 4 (${id}) initialized.`);

  } else {
    // Google Tag Manager (gtm.js) initialization
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${id}');`;
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${id}"
height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.prepend(noscript);
    
    console.log(`Google Tag Manager (${id}) initialized.`);
  }
};
